import Avatar from "@/components/ui/Avatar";
import Dropdown from "@/components/ui/Dropdown";
import withHeaderItem from "@/utils/hoc/withHeaderItem";
import { Link } from "react-router-dom";
import { PiUserDuotone, PiSignOutDuotone } from "react-icons/pi";
import type { JSX } from "react";
import useUiContext from "@/custolink-hooks/useUiContext";
import { useMutation } from "@tanstack/react-query";
import { AdmUserApi } from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";

type DropdownList = {
  label: string;
  path: string;
  icon: JSX.Element;
};

const dropdownItemList: DropdownList[] = [
  {
    label: "Profile",
    path: "/admin/profile",
    icon: <PiUserDuotone />,
  },
];

const _UserDropdown = () => {
  const uic = useUiContext();

  const m = useMutation({
    mutationFn: () => AdmUserApi.signout(),
  })

  return (
    <Dropdown
      className="flex"
      toggleClassName="flex items-center"
      renderTitle={
        <div className="cursor-pointer flex items-center">
          <Avatar size={32} icon={<PiUserDuotone />} />
        </div>
      }
      placement="bottom-end"
    >
      <Dropdown.Item variant="header">
        <div className="py-2 px-3 flex items-center gap-3">
          <Avatar icon={<PiUserDuotone />} />
          <div>
            <div className="font-bold text-gray-900 dark:text-gray-100">
              {uic.adminAreaAuthedUser.name}
            </div>
            <div className="text-xs">{uic.adminAreaAuthedUser.email}</div>
          </div>
        </div>
      </Dropdown.Item>
      <Dropdown.Item variant="divider" />
      {dropdownItemList.map((item) => (
        <Dropdown.Item key={item.label} eventKey={item.label} className="px-0">
          <Link className="flex h-full w-full px-2" to={item.path}>
            <span className="flex gap-2 items-center w-full">
              <span className="text-xl">{item.icon}</span>
              <span>{item.label}</span>
            </span>
          </Link>
        </Dropdown.Item>
      ))}

      <Dropdown.Item variant="divider" />
      <Dropdown.Item
        asElement="a"
        eventKey="Sign Out"
        className="px-0"
        onClick={async () => {
          await m.mutateAsync()
          document.location.reload();
        }}
      >
        <Link className="flex h-full w-full px-2" to={""}>
            <span className="flex gap-2 items-center w-full">
              <span className="text-xl"><PiSignOutDuotone /></span>
              <span>Sign off</span>
            </span>
        </Link>


      </Dropdown.Item>
    </Dropdown>
  );
};

const UserDropdown = withHeaderItem(_UserDropdown);

export default UserDropdown;
